export class Order {
   constructor(id, orden, id_cliente, fecha_preventa, fecha_entrega, notas_orden, descuento, subtotal, impuestos, Impg, ieps, iva, total, total_pagar){
      this.id = id
      this.orden = orden
      this.id_cliente = id_cliente
      this.fecha_preventa = fecha_preventa
      this.fecha_entrega = fecha_entrega
      this.notas_orden = notas_orden
      this.descuento = descuento
      this.subtotal = subtotal
      this.impuestos = impuestos
      this.Impg = Impg,
      this.ieps = ieps,
      this.iva = iva,
      this.total = total
      this.total_pagar = total_pagar
   }
   static fromServiceOrder (order) {
      return new Order(
         order.id,
         order.orden,
         order.id_cliente,
         order.fecha_preventa,
         order.fecha_entrega,
         order.notas_orden,
         order.descuento,
         order.subtotal,
         order.impuestos,
         order.Impg,
         order.ieps,
         order.iva,
         order.total,
         order.total_pagar
         );
   }   
}